/* @flow */
// typecheck: ignore file
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import BoxTitle from 'components/BoxTitle.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import Copy from 'components/Copy.jsx';
import CurrentUser from 'auth/CurrentUser';
import Divider from 'components/Divider.jsx';
import DropZoneModal from 'components/DropZoneModal.jsx';
import FamilyActions from 'actions/FamilyActions';
import File from 'entities/File';
import FileUploaderMixin from 'components/mixins/FileUploaderMixin';
import Heading from 'components/Heading.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import Progress from 'components/Progress.jsx';
import Row from 'components/Row.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/ParentalConsentSignatureView.scss';

type State = {
  card: ?Object,
  fileUploading: bool,
  isDraggingFileInner?: bool,
  uploadedFile?: ?File,
};

const ParentalConsentSignatureView = React.createClass({
  propTypes: {
    childId: React.PropTypes.number.isRequired,
    onProceed: React.PropTypes.func.isRequired,
  },

  mixins: [
    FileUploaderMixin,
  ],

  getInitialState(): State {
    return {
      card: null,
      fileUploading: false,
      loading: true,
      option: '',
    };
  },

  componentDidMount() {
    FamilyActions.sendConsentForm(this.props.childId);
  },

  getDropzoneId() {
    return 'parental_consent';
  },

  handleResendForm() {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Form resent');
    };

    const onError = () => {
      ToastActions.showErrorToast(`
        There was an error resending the form. Please try again or email
        ${LinkConstants.SUPPORT_EMAIL}
        for help.
      `);
    };

    FamilyActions
      .sendConsentForm(this.props.childId)
      .then(onSuccess, onError);
  },

  onUploadSuccess(file: File) {
    const onSuccess = () => {
      ToastActions.showSuccessToast('Photo upload successful');
      this.setState({ fileUploading: false });
      this.props.onProceed();
    };

    const onError = () => {
      ToastActions.showErrorToast(`
        There was an error uploading your photo. Please try again or email
        ${LinkConstants.SUPPORT_EMAIL}
        for help.
      `);
      this.setState({ fileUploading: false });
    };

    this.setState({ fileUploading: true });

    FamilyActions
      .sendConsentFile(this.props.childId, file.id)
      .then(onSuccess, onError);
  },

  renderDropzoneModal() {
    if (this.state.isDraggingFile) {
      return (
        <DropZoneModal
          title="Drag and drop form to upload"
          titleDrop="Drop form!"
          isFileUploaded={this.getFiles().length > 0}
          isHovering={this.state.isDraggingFileInner}
        />
      );
    } else {
      return null;
    }
  },

  renderBody() {
    if (this.state.fileUploading) {
      const percent = this.getFileData(this.getFiles()[0]).progress;

      return (
        <Container size="xxsmall">
          <Progress percent={percent} label="Uploading consent file" />
        </Container>
      );
    } else {
      return (
        <section>
          <BoxTitle>Print and sign a form</BoxTitle>
          <Row size="small">
            <Image src={require('assets/images/ParentalConsentSignatureView/form.svg')} />
          </Row>
          <Row size="medium">
            <Copy>
              <Heading level="3">Step 1: Print, read, and sign the permission form</Heading>
              <p>
                We sent the form to
                {' '}
                <b>
                  {CurrentUser.getUser().getEmail()}
                </b>.
                {' '}
                Didn’t get the email?
                {' '}
                <Link onClick={() => this.handleResendForm()}>Resend</Link>
              </p>
              <Divider size="medium" />
              <Heading level="3">Step 2: Upload a photo of the signed permission form</Heading>
              <p>
                The photo should include the entire form with the signature clearly visible.
              </p>
            </Copy>
          </Row>
          <Button full ref="dropzone_attach" className={`addFileButton_${this.getDropzoneId()}`}>
            Upload
          </Button>
          {this.renderDropzoneModal()}
        </section>
      );
    }
  },

  render() {
    return (
      <BoxBody ref="dropzone" className="ParentalConsentSignatureView">
        {this.renderBody()}
      </BoxBody>
    );
  },
});

export default ParentalConsentSignatureView;



// WEBPACK FOOTER //
// ./src/user/components/ParentalConsentSignatureView.jsx